import { useNavigate } from 'react-router-dom'
import ROUTES from '../../../assets/routes'
import { Box } from '@mui/material'
import { isAuthenticated } from '../../../util/authentication'
import { selectLoginConfiguration } from '../../../selectors/user'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'
import { redirectToAutoLogin } from '../../../util/authProvider'
import { isPinAuthGatePending } from '../../../util/pinBrowserFlags'
import { isEmbeddedModeSet } from '../../../util/general'
import PinSessionUnlockGate from './PinSessionUnlockGate'

const ProtectedRoute = ({ children }: any) => {
    const authenticated = isAuthenticated()
    const navigate = useNavigate()
    const pinGatePending = isPinAuthGatePending()
    const embedded = isEmbeddedModeSet()
    const loginConfiguration = useSelector(selectLoginConfiguration)

    useEffect(() => {
        if (embedded || authenticated) return
        if (pinGatePending) {
            navigate(ROUTES.login, { replace: true })
            return
        }
        if (loginConfiguration.autoLoginEnabled) {
            void redirectToAutoLogin()
            return
        }
        navigate(ROUTES.login, { replace: true })
    }, [authenticated, embedded, loginConfiguration.autoLoginEnabled, navigate, pinGatePending])

    if (!authenticated) {
        return null
    }

    return (
        <PinSessionUnlockGate>
            <Box sx={{ width: '100%', height: '100%' }}>{children}</Box>
        </PinSessionUnlockGate>
    )
}

export default ProtectedRoute
